import { FieldValues, Path, useFormContext, useWatch } from "react-hook-form";
import ValidatedTextField from "./ValidatedTextField";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import { TextFieldElementProps } from "react-hook-form-mui";

interface IProps<T extends FieldValues = FieldValues>
    extends Omit<TextFieldElementProps, "name" | "value" | "onChange"> {
    name: Path<T>;
    label?: string;
    readOnly: boolean;
    labelSize?: number;
    inputSize?: number;
    multiLine?: boolean;
    rows?: number;
    alwaysShow?: boolean;
    type?: string;
    min?: number;
    max?: number;
    endAdornment?: string;
    readOnlyFormat?: (value: string | number | null | undefined) => string;
    fixedDecimalScale?: number;
    integerOnly?: boolean;
}

export default function RenderTextField<T extends FieldValues = FieldValues>({
    label,
    name,
    readOnly,
    labelSize = 8,
    inputSize = 4,
    multiLine,
    rows,
    alwaysShow = multiLine,
    type,
    min,
    max,
    endAdornment,
    readOnlyFormat,
    fixedDecimalScale,
    integerOnly,
    ...rest
}: IProps<T>) {
    const { control } = useFormContext<T>();
    const value = useWatch({ control, name });

    if (!alwaysShow && readOnly && (value === null || value === undefined)) return null;

    return (
        <Grid container size={12}>
            {label && (
                <Grid size={labelSize} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="body1">{label}</Typography>
                </Grid>
            )}
            <Grid size={label == null ? 12 : inputSize}>
                <ValidatedTextField
                    name={name}
                    readOnly={readOnly}
                    multiline={multiLine}
                    rows={rows}
                    type={type}
                    min={min}
                    max={max}
                    endAdornment={endAdornment}
                    readOnlyFormat={readOnlyFormat}
                    fixedDecimalScale={fixedDecimalScale}
                    integerOnly={integerOnly}
                    {...rest}
                />
            </Grid>
        </Grid>
    );
}
